import type { TFeatureFlags } from '@/api/endpoints/featureFlags';
import type { EFeatureFlags } from '@/shared/consts';

import { getCookie } from '../cookies';

let featureFlags: TFeatureFlags | null = null;

export function setFeatureFlagsGlobalState(flags: TFeatureFlags | null) {
  featureFlags = flags;
}

/**
 * Проверяет доступен ли функционал по значению флага.
 * Значение флага из куков пользователя (их проставляют исключительно для тестирования) выше, чем значения в flipper.
 */
export function checkIsFlagEnabled(flag: EFeatureFlags): boolean {
  const cookieValue = getCookie(flag);
  const isDynamicFlagEnabled = Boolean(featureFlags?.[flag]);

  return cookieValue === 'true' || isDynamicFlagEnabled;
}
